module.exports = __webpack_public_path__ + "img/nft_owner.3f9f92b8.gif";